import _classCallCheck from "C:\\Users\\Vishnu\\source\\repos\\DR\\NetCore\\CoreApp\\Client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\Vishnu\\source\\repos\\DR\\NetCore\\CoreApp\\Client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\Users\\Vishnu\\source\\repos\\DR\\NetCore\\CoreApp\\Client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\Users\\Vishnu\\source\\repos\\DR\\NetCore\\CoreApp\\Client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\Users\\Vishnu\\source\\repos\\DR\\NetCore\\CoreApp\\Client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import { DateComponent, mapHash, memoize } from '@fullcalendar/core/internal.js';
import { createRef, createElement } from '@fullcalendar/core/preact.js';
import { DayTableSlicer, Table, TableView, buildDayTableModel } from '@fullcalendar/daygrid/internal.js';
import { VResourceJoiner, VResourceSplitter, flattenResources, DEFAULT_RESOURCE_ORDER, ResourceDayHeader, DayResourceTableModel, ResourceDayTableModel } from '@fullcalendar/resource/internal.js';

var ResourceDayTableJoiner = /*#__PURE__*/function (_VResourceJoiner) {
  _inherits(ResourceDayTableJoiner, _VResourceJoiner);

  function ResourceDayTableJoiner() {
    _classCallCheck(this, ResourceDayTableJoiner);

    return _possibleConstructorReturn(this, _getPrototypeOf(ResourceDayTableJoiner).apply(this, arguments));
  }

  _createClass(ResourceDayTableJoiner, [{
    key: "transformSeg",
    value: function transformSeg(seg, resourceDayTableModel, resourceI) {
      var colRanges = resourceDayTableModel.computeColRanges(seg.firstCol, seg.lastCol, resourceI);
      return colRanges.map(function (colRange) {
        return Object.assign(Object.assign(Object.assign({}, seg), colRange), {
          isStart: seg.isStart && colRange.isStart,
          isEnd: seg.isEnd && colRange.isEnd
        });
      });
    }
  }]);

  return ResourceDayTableJoiner;
}(VResourceJoiner);

var ResourceDayTable = /*#__PURE__*/function (_DateComponent) {
  _inherits(ResourceDayTable, _DateComponent);

  function ResourceDayTable() {
    var _this;

    _classCallCheck(this, ResourceDayTable);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ResourceDayTable).apply(this, arguments));
    _this.splitter = new VResourceSplitter();
    _this.slicers = {};
    _this.joiner = new ResourceDayTableJoiner();
    _this.tableRef = createRef();

    _this.isHitComboAllowed = function (hit0, hit1) {
      var allowAcrossResources = _this.props.resourceDayTableModel.dayTableModel.colCnt === 1;
      return allowAcrossResources || hit0.dateSpan.resourceId === hit1.dateSpan.resourceId;
    };

    return _this;
  }

  _createClass(ResourceDayTable, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var props = this.props,
          context = this.context;
      var resourceDayTableModel = props.resourceDayTableModel,
          nextDayThreshold = props.nextDayThreshold,
          dateProfile = props.dateProfile;
      var splitProps = this.splitter.splitProps(props);
      this.slicers = mapHash(splitProps, function (split, resourceId) {
        return _this2.slicers[resourceId] || new DayTableSlicer();
      });
      var slicedProps = mapHash(this.slicers, function (slicer, resourceId) {
        return slicer.sliceProps(splitProps[resourceId], dateProfile, nextDayThreshold, context, resourceDayTableModel.dayTableModel);
      });
      return createElement(Table, Object.assign({
        forPrint: props.forPrint,
        ref: this.tableRef
      }, this.joiner.joinProps(slicedProps, resourceDayTableModel), {
        cells: resourceDayTableModel.cells,
        dateProfile: dateProfile,
        colGroupNode: props.colGroupNode,
        tableMinWidth: props.tableMinWidth,
        renderRowIntro: props.renderRowIntro,
        dayMaxEvents: props.dayMaxEvents,
        dayMaxEventRows: props.dayMaxEventRows,
        showWeekNumbers: props.showWeekNumbers,
        expandRows: props.expandRows,
        headerAlignElRef: props.headerAlignElRef,
        clientWidth: props.clientWidth,
        clientHeight: props.clientHeight,
        isHitComboAllowed: this.isHitComboAllowed
      }));
    }
  }]);

  return ResourceDayTable;
}(DateComponent);

var ResourceDayTableView = /*#__PURE__*/function (_TableView) {
  _inherits(ResourceDayTableView, _TableView);

  function ResourceDayTableView() {
    var _this3;

    _classCallCheck(this, ResourceDayTableView);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(ResourceDayTableView).apply(this, arguments));
    _this3.flattenResources = memoize(flattenResources);
    _this3.buildResourceDayTableModel = memoize(buildResourceDayTableModel);
    _this3.headerRef = createRef();
    _this3.tableRef = createRef(); // can't override any lifecycle methods from parent

    return _this3;
  }

  _createClass(ResourceDayTableView, [{
    key: "render",
    value: function render() {
      var _this4 = this;

      var props = this.props,
          context = this.context;
      var options = context.options;
      var resourceOrderSpecs = options.resourceOrder || DEFAULT_RESOURCE_ORDER;
      var resources = this.flattenResources(props.resourceStore, resourceOrderSpecs);
      var resourceDayTableModel = this.buildResourceDayTableModel(props.dateProfile, context.dateProfileGenerator, resources, options.datesAboveResources, context);
      var headerContent = options.dayHeaders && createElement(ResourceDayHeader, {
        ref: this.headerRef,
        resources: resources,
        dateProfile: props.dateProfile,
        dates: resourceDayTableModel.dayTableModel.headerDates,
        datesRepDistinctDays: true
      });

      var bodyContent = function bodyContent(contentArg) {
        return createElement(ResourceDayTable, {
          ref: _this4.tableRef,
          dateProfile: props.dateProfile,
          resourceDayTableModel: resourceDayTableModel,
          businessHours: props.businessHours,
          eventStore: props.eventStore,
          eventUiBases: props.eventUiBases,
          dateSelection: props.dateSelection,
          eventSelection: props.eventSelection,
          eventDrag: props.eventDrag,
          eventResize: props.eventResize,
          nextDayThreshold: options.nextDayThreshold,
          tableMinWidth: contentArg.tableMinWidth,
          colGroupNode: contentArg.tableColGroupNode,
          dayMaxEvents: options.dayMaxEvents,
          dayMaxEventRows: options.dayMaxEventRows,
          showWeekNumbers: options.weekNumbers,
          expandRows: !props.isHeightAuto,
          headerAlignElRef: _this4.headerElRef,
          clientWidth: contentArg.clientWidth,
          clientHeight: contentArg.clientHeight,
          forPrint: props.forPrint
        });
      };

      return options.dayMinWidth ? this.renderHScrollLayout(headerContent, bodyContent, resourceDayTableModel.colCnt, options.dayMinWidth) : this.renderSimpleLayout(headerContent, bodyContent);
    }
  }]);

  return ResourceDayTableView;
}(TableView);

function buildResourceDayTableModel(dateProfile, dateProfileGenerator, resources, datesAboveResources, context) {
  var dayTable = buildDayTableModel(dateProfile, dateProfileGenerator);
  return datesAboveResources ? new DayResourceTableModel(dayTable, resources, context) : new ResourceDayTableModel(dayTable, resources, context);
}

export { ResourceDayTable, ResourceDayTableView };